import React from 'react';
import { Box, Typography, Grid } from '@availity/element';
import { useNavigate } from 'react-router-dom';
import Button from '../../Utils/components/Button';
import StatisticCard from './StatisticCard';
import { gradients } from '../../../static/constants/theme';

const HeroSection = () => {
  const navigate = useNavigate();

  const stats = [
    { value: '500K+', label: 'Active Providers' },
    { value: '6,000+', label: 'Hospitals Connected' },
    { value: '99.9%', label: 'Uptime SLA' },
    { value: '50+ States', label: 'Nationwide Coverage' },
  ];

  return (
    <Box
      sx={{
        width: 1,
        height: { md: '715px' },
        minHeight: 'auto',
        pt: { xs: 6, sm: 8, md: '164px' },
        pb: { xs: 3, sm: 4, md: '64px' },
        px: { xs: 2, md: 0 },
        backgroundImage: gradients.background,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 6, sm: 8, md: '164px' },
        borderBottomWidth: { md: '2px' },
        opacity: 1,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: 1,
          height: 1,
          pointerEvents: 'none',
          zIndex: 0,
          opacity: 0.8,
          display: { xs: 'none', md: 'block' },
        }}
      >
        <Box
          component="iframe"
          src="/static/assets/backgrounds/API-Home-Hero-BG-FALSE.html"
          sx={{
            width: 1,
            height: 1,
            border: 'none',
            display: 'block',
          }}
          scrolling="no"
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: { xs: 4.875, md: '39px' },
            height: { md: '261px' },
            opacity: 1,
          }}
        >
          <Box
            sx={{
              width: { xs: 1, md: 730 },
              maxWidth: 730,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <Typography
              variant="h1"
              sx={{
                textAlign: 'center',
                color: 'common.white',
                fontSize: { xs: 36, md: 56 },
                fontFamily: 'Montserrat',
                fontWeight: 600,
                lineHeight: { xs: 1.25, md: 1.21 },
                m: 0,
              }}
            >
              Your API Experience.
            </Typography>
            <Typography
              variant="h1"
              sx={{
                textAlign: 'center',
                color: 'common.white',
                fontSize: { xs: 36, md: 56 },
                fontFamily: 'Montserrat',
                fontWeight: 600,
                lineHeight: { xs: 1.25, md: 1.21 },
                m: 0,
              }}
            >
              One Platform Gateway.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: 'center',
                color: 'common.white',
                fontSize: 24,
                fontFamily: 'Lato',
                fontWeight: 400,
                lineHeight: 1.25,
                m: 0,
                px: { xs: 2, sm: 0 },
                whiteSpace: { xs: 'normal', md: 'nowrap' },
              }}
            >
              Seamless, secure, and scalable solutions for payers, providers, and partners.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Button variant="navbar" onClick={() => navigate('/docs/overview')}>
              Explore APIs
            </Button>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        justifyContent={{ xs: 'center', sm: 'space-between', md: 'center' }}
        alignItems="center"
        spacing={{ xs: 5.75, sm: 5.125, md: 12.625 }}
        sx={{
          maxWidth: { xs: '100%', sm: 'auto', md: 'auto' },
          height: { sm: '62px' },
          opacity: 1,
          position: 'relative',
          zIndex: 1,
        }}
      >
        {stats.map((stat) => (
          <Grid item key={stat.label}>
            <StatisticCard value={stat.value} label={stat.label} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HeroSection;